import { motion } from 'framer-motion';
import { Gavel, Users, Handshake, ClipboardCheck, Key } from 'lucide-react';

const saleTypes = [
  {
    icon: Gavel,
    title: 'Biddit',
    description: 'Plateforme officielle des ventes notariales en ligne.',
    howWeHelp:
      'Nous organisons les visites selon le calendrier imposé par la plateforme Biddit, en respectant scrupuleusement les délais.',
    features: [
      'Respect strict du calendrier Biddit',
      'Accueil des candidats acquéreurs',
      'Remise du cahier des charges sur place',
    ],
  },
  {
    icon: Users,
    title: 'Ventes Publiques',
    description: 'Ventes aux enchères traditionnelles en salle.',
    howWeHelp:
      'Pour les ventes publiques classiques, nous organisons les visites groupées et assurons un accompagnement professionnel des visiteurs.',
    features: [
      'Organisation de visites groupées',
      'Planification flexible avant la vente',
      'Accompagnement personnalisé des visiteurs',
    ],
  },
  {
    icon: Handshake,
    title: 'Gré à Gré',
    description: 'Ventes amiables entre particuliers ou via notaire.',
    howWeHelp:
      'Dans le cadre des ventes de gré à gré, nous gérons l\'intégralité des visites avec une flexibilité totale sur les créneaux.',
    features: [
      'Flexibilité totale des créneaux',
      'Gestion complète de l\'agenda',
      'Rapport détaillé après chaque visite',
    ],
  },
];

export function SaleTypes() {
  return (
    <section id="sale-types" className="py-24 bg-cream/50">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-50 text-gold-700 text-sm font-medium border border-gold-200 mb-6"
          >
            Polyvalence
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl font-display font-bold text-navy-600 mb-6"
          >
            Adaptés à{' '}
            <span className="gradient-text">tous types</span> de ventes
          </motion.h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {saleTypes.map((type, index) => (
            <motion.div
              key={type.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="rounded-2xl bg-white p-8 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-14 h-14 rounded-xl bg-navy-600 flex items-center justify-center mb-6">
                <type.icon className="w-7 h-7 text-gold-400" />
              </div>
              <h3 className="text-2xl font-display font-semibold text-navy-600 mb-2">
                {type.title}
              </h3>
              <p className="text-navy-300 leading-relaxed mb-4">
                {type.description}
              </p>
              <p className="text-navy-400 text-sm leading-relaxed mb-6">
                {type.howWeHelp}
              </p>
              <ul className="space-y-2">
                {type.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2 text-sm text-navy-600">
                    <ClipboardCheck className="w-4 h-4 text-gold-500 flex-shrink-0 mt-0.5" />
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Bottom badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-12"
        >
          <div className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-navy-50 text-navy-600 font-medium border border-navy-100">
            <Key className="w-5 h-5 text-gold-500" />
            Partenaire de confiance des professionnels de l'immobilier
          </div>
        </motion.div>
      </div>
    </section>
  );
}
